import { jsx as _jsx } from "react/jsx-runtime";
var LineWithRoundedCaps = function () {
    {
        /* Hack for underline with rounded end caps */
    }
    return _jsx("div", { className: "rounded-full h-[2px] w-full bg-shoe" });
};
export default LineWithRoundedCaps;
